import LoginWidget from "./LoginWidget";

export default LoginWidget;
